export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.a4bcaca776b2c44dcf6180e03ca953dd.css";